module.exports = __webpack_public_path__ + "static/media/loading.f919d914.gif";